import Phaser from 'phaser';
import { language } from './language';
import { CST } from '../CST';
import config from '../helpers/config';

var clickSound;
let count = 0;

export default class Rules extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.RULES1);
	}

	preload() {
		this.load.image('rules1', 'assets/english/Rules1.png');
		this.load.image('back_btn', 'assets/english/go-backwards.png');
		this.load.image('close_btn', 'assets/english/close.png');
		this.load.image('next_btn', 'assets/english/go-forward.png');
		this.load.image('btn-video', 'assets/english/btn-video.png');
	}

	create(data) {
		clickSound = this.sound.add('clickSound');
		this.chatChannel = new BroadcastChannel('chat_channel');

		this.scene.bringToTop();

		this.bg = this.add.image(
			this.cameras.main.width / 2,
			this.cameras.main.height / 2,
			'rules1' + language,
		);

		if (!config.isViewOnly) {
			// X = -690 Y = -425
			this.backBtn = this.add
				.image(
					this.cameras.main.width / 2 - 160,
					this.cameras.main.height / 2 + 420,
					'back_btn' + language,
				)
				.setScale(1.2)
				.setInteractive({
					useHandCursor: true,
				})
				.on('pointerdown', () => {
					count--;
					this.rulesPage(count);
					this.chatChannel.postMessage(JSON.stringify({ action: 'prev-page' }));
				})
				.setVisible(false);

			//X = +690 Y = -425
			// this.nextBtn = this.add
			// 	.image(
			// 		this.cameras.main.width / 2 + 160,
			// 		this.cameras.main.height / 2 + 420,
			// 		'next_btn' + language,
			// 	)
			// 	.setScale(1.2)
			// 	.setInteractive({
			// 		useHandCursor: true,
			// 	})
			// 	.on('pointerdown', () => {
			// 		count++;
			// 		this.rulesPage(count);
			// 		this.chatChannel.postMessage(JSON.stringify({ action: 'next-page' }));
			// 	});

			this.closeBtn = this.add
				.image(
					this.cameras.main.width / 2,
					this.cameras.main.height / 2 + 405,
					'close_btn' + language,
				)
				.setScale(1.2)
				.setInteractive({
					useHandCursor: true,
				})
				.on('pointerdown', () => {
					clickSound.play();
					count = 0;
					this.scene.stop();
					this.scene.resume(data.scene, { data: 5 });
					this.chatChannel.postMessage(JSON.stringify({ action: 'close-rules' }));
				});

			this.videoBtn = this.add
				.image(260, this.cameras.main.height / 2 + 405, 'btn-video')
				.setScale(0.9)
				.setInteractive({ useHandCursor: true })
				.on('pointerdown', () => {
					clickSound.play();
					this.videoBtn.disableInteractive();
					this.showVideo();
				});

			if (/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
				this.backBtn.x = this.cameras.main.width / 2 - 330;
				// this.nextBtn.x = this.cameras.main.width / 2 + 330;
				this.closeBtn.x = this.cameras.main.width / 2 - 650;
				this.closeBtn.y = this.cameras.main.height / 2 - 410;
			}
		} else {
			this.chatChannel.onmessage = event => {
				const data = JSON.parse(event.data);

				switch (data.action) {
					case 'prev-page':
						count--;
						this.rulesPage(count);
						break;
					case 'next-page':
						count++;
						this.rulesPage(count);
						break;
					case 'close-rules':
						count = 0;
						this.scene.stop();
						this.scene.resume(data.scene, { data: 5 });
						break;

					default:
						break;
				}
			};
		}
	}

	showVideo() {
		// Native HTML video player — browser provides all controls natively

		// Size the overlay to match exactly the game canvas, not the full viewport.
		// This ensures the close button never lands in the black bars outside the canvas.
		const rect = this.game.canvas.getBoundingClientRect();
		const container = document.createElement('div');
		container.style.cssText =
			`position:fixed;top:${rect.top}px;left:${rect.left}px;` +
			`width:${rect.width}px;height:${rect.height}px;` +
			`background:#000;z-index:99999;`;

		const vid = document.createElement('video');
		vid.src = 'assets/english/Video/how-to-use-leadership-team-roulette-web.mp4';
		vid.style.cssText = 'width:100%;height:100%;display:block;object-fit:contain;';
		vid.setAttribute('controls', '');
		vid.setAttribute('playsinline', '');
		vid.addEventListener('ended', () => this.closeVideo());

		// Close button — always inside the canvas/video area
		const closeBtn = document.createElement('img');
		closeBtn.src = 'assets/english/close.png';
		closeBtn.style.cssText =
			'position:absolute;top:15px;right:15px;width:130px;cursor:pointer;opacity:0.9;transition:transform 0.1s,opacity 0.1s;';
		closeBtn.addEventListener('click', () => this.closeVideo());
		closeBtn.addEventListener('mouseover', () => {
			closeBtn.style.opacity = '1';
			closeBtn.style.transform = 'scale(1.1)';
		});
		closeBtn.addEventListener('mouseout', () => {
			closeBtn.style.opacity = '0.9';
			closeBtn.style.transform = 'scale(1)';
		});

		container.appendChild(vid);
		container.appendChild(closeBtn);
		document.body.appendChild(container);

		this._videoContainer = container;
		this._nativeVideo = vid;

		vid.play().catch(() => {});

		// Cleanup if scene shuts down while video is open
		this._videoShutdownCleanup = () => this.closeVideo();
		this.events.once('shutdown', this._videoShutdownCleanup);
	}

	closeVideo() {
		this.events.off('shutdown', this._videoShutdownCleanup);
		if (this._nativeVideo) {
			this._nativeVideo.pause();
			this._nativeVideo.src = '';
			this._nativeVideo = null;
		}
		if (this._videoContainer) {
			this._videoContainer.remove();
			this._videoContainer = null;
		}
		this.videoBtn.setInteractive({ useHandCursor: true });
	}

	rulesPage(count) {
		clickSound.play();
		switch (count) {
			case 0:
				this.bg.setTexture('rules1' + language);
				this.backBtn.disableInteractive().setVisible(false);
				this.nextBtn.setInteractive().setVisible(true);
				break;
			case 1:
				this.bg.setTexture('rules2' + language);
				this.backBtn.setInteractive().setVisible(true);
				this.nextBtn.disableInteractive().setVisible(false);
				break;
			// case 2:
			//   this.bg.setTexture("rules3" + language);
			//   this.nextBtn.setInteractive().setVisible(true);
			//   break;
			// case 3:
			//   this.bg.setTexture("rules4" + language);
			//   this.nextBtn.disableInteractive().setVisible(false);
			//   break;
		}
	}
}

